import { ADMINISTRATEUR, SUPER_ADMIN, USER, APPEL_OFFRE, COMMERCIAL, PROJET, INTERVENTION, FORMATION, GESTION_PSY } from "../../constantes/mainConstantes"
import { isAuth } from "./isAuth"

export function hasRoles() {
  if (isAuth() && getRole()) {
    const roles = getRoles()
    if (roles.includes(ADMINISTRATEUR) || roles.includes(SUPER_ADMIN)) return 'administrateur'
    if (roles.includes(GESTION_PSY)) return 'gestion_psy'
    if (roles.includes(FORMATION)) return 'formation'
    if (roles.includes(APPEL_OFFRE)) return 'appel_offre'
    if (roles.includes(COMMERCIAL)) return 'commercial'
    if (roles.includes(PROJET)) return 'projet'
    if (roles.includes(INTERVENTION)) return 'intervention'
    if (roles.includes(USER)) return 'user'
    return null
  }
}

export function isSuperAdmin() {
  if (isAuth() && getRole()) {
    const roles = getRoles()
    return roles.includes(SUPER_ADMIN)
  }
}

export function isAdministrateur() {
  if (isAuth() && getRole()) {
    const roles = getRoles()
    return roles.includes(ADMINISTRATEUR) || roles.includes(SUPER_ADMIN)
  }
}

export function isGestionPsy() {
  if (isAuth() && getRole()) {
    const roles = getRoles()
    return roles.includes(GESTION_PSY) || roles.includes(ADMINISTRATEUR) || roles.includes(SUPER_ADMIN)
  }
}

export function isAppelOffreOrCommercialOrProjetOrGestionPsy() {
  if (isAuth() && getRole()) {
    const roles = getRoles()
    return roles.includes(FORMATION)
      || roles.includes(APPEL_OFFRE)
      || roles.includes(COMMERCIAL)
      || roles.includes(PROJET)
      || roles.includes(GESTION_PSY)
      || roles.includes(ADMINISTRATEUR)
      || roles.includes(SUPER_ADMIN)
  }
}

export function isFormation() {
  if (isAuth() && getRole()) {
    const roles = getRoles()
    return roles.includes(FORMATION) || roles.includes(ADMINISTRATEUR) || roles.includes(SUPER_ADMIN)
  }
}

export function isIntervention() {
  if (isAuth() && getRole()) {
    const roles = getRoles()
    return roles.includes(INTERVENTION) || roles.includes(ADMINISTRATEUR) || roles.includes(SUPER_ADMIN)
  }
}

function getRole() {
  try {
    const raw = localStorage.getItem('REACT_ROLE')
    if (!raw) return null
    return JSON.parse(raw)
  } catch {
    localStorage.removeItem('REACT_ROLE')
    return null
  }
}

function getRoles() {
  const r = getRole()
  return Array.isArray(r) ? r : []
}

export function hasOneOfRoles(roles: string[] = []) {
  const userRoles = getRoles()
  if (isAuth() && userRoles.length) {
    return userRoles.some(r => roles.includes(r))
  }
  return false;
}